import httpClient from '../../httpClient'

export interface ICheckEligibilityResponse {
  can_create: boolean
  requires_subscription: boolean
  interview_count: number
  remaining: number
}

const interviewEligibilityController = {
  checkEligibility: async (email: string): Promise<ICheckEligibilityResponse> => {
    const response = await httpClient.get<ICheckEligibilityResponse>(
      '/interviews/check_eligibility',
      {
        params: { email },
      }
    )
    return response.data
  },
}

export default interviewEligibilityController
